import { prepareCommonCarriageData } from "./sendCarriageCommon";
import { type LinearConfiguratorState } from "../../Linear/redux/types";
import { getCsrfValue } from "../../../api/ApiHelper";
import { type PriceInfo } from "../../../api/pna/PriceInfo";

export function sendCarriageAddToCart(
  linearState: LinearConfiguratorState,
  priceInfo: PriceInfo | null,
): Promise<string> {
  const data = prepareCommonCarriageData(linearState, priceInfo);

  return fetch(window.location.href.substring(0, window.location.href.lastIndexOf("/")) + "/addToCart2", {
    body: JSON.stringify(data),
    cache: "no-cache",
    credentials: "same-origin",
    method: "POST",
    mode: "cors",
    headers: {
      dataType: "json",
      "content-type": "application/json",
      CSRFToken: getCsrfValue(),
    },
    redirect: "follow",
  }).then((result) => {
    if (result.ok) {
      return result.json();
    } else {
      console.error(`Error sending carriage update: ${result.status}`);
      throw new Error(result.status + "");
    }
  });
}
